//Reference: EN073
//Reference: EN072

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';


export class New extends Mappeable {

    fileDocument: string;
    txtName: string;
    txtUrl: string;
    datePublication: string;
    typeDocument: string;
    principal: boolean;
    txtNews: string;


    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            fileDocument: this.fileDocument,
            txtName: this.txtName,
            txtUrl: this.txtUrl,
            datePublication: moment(this.datePublication).format("YYYY-MM-DD"),
            typeDocument: "png",
            principal: this.principal,
            txtNews: this.txtNews
        }
    }


}

